import { styled, YStack } from 'tamagui';

export const StyledCard = styled(YStack, {
  borderWidth: 2,
  borderColor: 'rgba(255, 255, 255, 0.05)',
  borderRadius: 16,
  backgroundColor: 'transparent',
  backgroundImage: 'linear-gradient(180deg, #2A2A2A 0%, #161616 100%)',
  padding: '$5',
  gap: '$5',
});
